module.exports={
    //Cim:"http://localhost:3000"
    Cim: "https://nodejs201.dszcbaross.edu.hu"
    
}


